import { render, staticRenderFns } from "./UEditor.vue?vue&type=template&id=9075c3c6&"
import script from "./UEditor.vue?vue&type=script&lang=js&"
export * from "./UEditor.vue?vue&type=script&lang=js&"
import style0 from "./UEditor.vue?vue&type=style&index=0&id=9075c3c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports